import { startCase } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ReportListingView = ({ setViewShowModal, item }) => {
  const { t } = useTranslation()
  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <form className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('O_VIEW_USER')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setViewShowModal(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className=' border-2 rounded-md p-5'>
                  <div className='grid grid-cols-2 '>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_NAME')}:</strong>
                      </div>
                      <div>
                        {startCase(item?.user?.firstName) +
                          ' ' +
                          startCase(item?.user?.lastName)}
                      </div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_MOBILE')}:</strong>
                      </div>
                      <div>{`( ${startCase(
                        item?.user?.countryCode
                      )} ) ${startCase(item?.user?.mobile)}`}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_REASON')}:</strong>
                      </div>
                      <div>{startCase(item?.reason?.name)}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_EMAIL_ID')}:</strong>
                      </div>
                      <div>{item?.user?.email || 'N/A'}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_PROPERTY_NAME')}:</strong>
                      </div>
                      <div>{startCase(item?.property?.title)}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_USER_TYPE')}:</strong>
                      </div>
                      <div>{startCase(item?.userType)}</div>
                    </div>
                    <div className='mb-3 word-wrap'>
                      <div className=''>
                        <strong>{t('O_ADDITIONAL_COMMENT')}:</strong>
                      </div>
                      <div style={{wordWrap:'break-word'}}>{item?.comment}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setViewShowModal(false)}
                >
                  {t('O_CLOSE')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default ReportListingView
